import {
  GuestUser,
  UserStatus,
  GuestType,
  UsersSummary,
  AccessLevel,
  ServiceStatus,
} from '../../apis/users/users.api.interfaces';

export const mockGuestUsers: GuestUser[] = [
  {
    id: 'guest-1',
    firstName: 'Dr. Priya',
    lastName: 'Krishnan',
    email: 'priya.krishnan@university.edu',
    phone: '+91-9876543290',
    status: UserStatus.ACTIVE,
    createdDate: '2024-01-10',
    lastActive: '2024-01-16',
    guestType: GuestType.SPEAKER,
    organization: 'Indian Institute of Science',
    designation: 'Professor of Physics',
    eventId: 'EVENT001',
    eventName: 'Science Symposium 2024',
    invitedBy: 'Dr. Vikram Rao',
    invitationDate: '2024-01-05',
    accessLevel: AccessLevel.FULL,
    accommodation: {
      roomNumber: '201',
      building: 'Guest House A',
      checkInDate: '2024-01-15',
      checkOutDate: '2024-01-17',
      specialRequirements: 'Vegetarian meals, early checkout',
    },
    services: [
      {
        id: 'service-1',
        serviceName: 'Keynote Speaking',
        description: 'Opening keynote on "Future of Physics Education"',
        startDate: '2024-01-16',
        endDate: '2024-01-16',
        cost: 25000,
        status: ServiceStatus.COMPLETED,
      },
      {
        id: 'service-2',
        serviceName: 'Student Interaction Session',
        description: 'Q&A session with Class 11 and 12 students',
        startDate: '2024-01-16',
        endDate: '2024-01-16',
        status: ServiceStatus.COMPLETED,
      },
    ],
    documents: [
      {
        id: 'doc-1',
        type: 'Identity Proof',
        name: 'Passport Copy',
        uploadDate: '2024-01-08',
        verified: true,
      },
      {
        id: 'doc-2',
        type: 'Academic Credentials',
        name: 'PhD Certificate',
        uploadDate: '2024-01-08',
        verified: true,
      },
    ],
    address: {
      street: 'IISc Campus',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560012',
      country: 'India',
    },
    notes:
      'Renowned physicist, excellent speaker. Students loved the interaction session.',
  },
  {
    id: 'guest-2',
    firstName: 'Mark',
    lastName: 'Thompson',
    email: 'mark.thompson@buildcorp.com',
    phone: '+91-9876543300',
    status: UserStatus.ACTIVE,
    createdDate: '2024-01-12',
    lastActive: '2024-01-19',
    guestType: GuestType.CONTRACTOR,
    organization: 'BuildCorp Solutions',
    designation: 'Project Manager',
    invitedBy: 'Mrs. Kavita Singh',
    invitationDate: '2024-01-10',
    accessLevel: AccessLevel.STANDARD,
    accommodation: undefined,
    services: [
      {
        id: 'service-3',
        serviceName: 'Library Renovation',
        description: 'Complete renovation of library infrastructure',
        startDate: '2024-01-20',
        endDate: '2024-03-15',
        cost: 500000,
        status: ServiceStatus.ACTIVE,
      },
      {
        id: 'service-4',
        serviceName: 'Safety Inspection',
        description: 'Monthly safety compliance inspection',
        startDate: '2024-01-15',
        endDate: '2024-01-15',
        cost: 5000,
        status: ServiceStatus.COMPLETED,
      },
    ],
    documents: [
      {
        id: 'doc-3',
        type: 'Business License',
        name: 'Construction License',
        uploadDate: '2024-01-12',
        verified: true,
      },
      {
        id: 'doc-4',
        type: 'Insurance',
        name: 'Liability Insurance',
        uploadDate: '2024-01-12',
        verified: true,
      },
    ],
    address: {
      street: '300 Industrial Estate',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560045',
      country: 'India',
    },
    notes:
      'Reliable contractor with excellent safety record. Ongoing library renovation project.',
  },
  {
    id: 'guest-3',
    firstName: 'Anita',
    lastName: 'Desai',
    email: 'anita.desai@volunteer.org',
    phone: '+91-9876543310',
    status: UserStatus.PENDING,
    createdDate: '2024-01-18',
    lastActive: '2024-01-18',
    guestType: GuestType.VOLUNTEER,
    organization: 'Education for All NGO',
    designation: 'Program Coordinator',
    eventId: 'EVENT002',
    eventName: 'Community Outreach Program',
    invitedBy: 'Mrs. Meera Joshi',
    invitationDate: '2024-01-15',
    accessLevel: AccessLevel.LIMITED,
    accommodation: undefined,
    services: [
      {
        id: 'service-5',
        serviceName: 'Community Teaching',
        description: 'Teaching underprivileged children in nearby communities',
        startDate: '2024-01-25',
        endDate: '2024-02-25',
        status: ServiceStatus.PENDING,
      },
    ],
    documents: [
      {
        id: 'doc-5',
        type: 'Background Check',
        name: 'Police Verification',
        uploadDate: '2024-01-18',
        verified: false,
      },
      {
        id: 'doc-6',
        type: 'NGO Registration',
        name: 'NGO Certificate',
        uploadDate: '2024-01-18',
        verified: true,
      },
    ],
    address: {
      street: '45 Social Sector',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560029',
      country: 'India',
    },
    notes:
      'Pending background verification for volunteer program. Experienced in community education.',
  },
  {
    id: 'guest-4',
    firstName: 'James',
    lastName: 'Wilson',
    email: 'james.wilson@techvendor.com',
    phone: '+91-9876543320',
    status: UserStatus.ACTIVE,
    createdDate: '2024-01-08',
    lastActive: '2024-01-19',
    guestType: GuestType.VENDOR,
    organization: 'TechVendor Solutions',
    designation: 'Sales Manager',
    invitedBy: 'Mr. Ravi Kumar',
    invitationDate: '2024-01-05',
    accessLevel: AccessLevel.STANDARD,
    accommodation: undefined,
    services: [
      {
        id: 'service-6',
        serviceName: 'Software Training',
        description: 'Training teachers on new educational software',
        startDate: '2024-01-20',
        endDate: '2024-01-22',
        cost: 15000,
        status: ServiceStatus.ACTIVE,
      },
      {
        id: 'service-7',
        serviceName: 'System Maintenance',
        description: 'Quarterly system maintenance and updates',
        startDate: '2024-01-19',
        endDate: '2024-01-19',
        cost: 8000,
        status: ServiceStatus.COMPLETED,
      },
    ],
    documents: [
      {
        id: 'doc-7',
        type: 'Vendor Agreement',
        name: 'Service Contract',
        uploadDate: '2024-01-08',
        verified: true,
      },
      {
        id: 'doc-8',
        type: 'Tax Registration',
        name: 'GST Certificate',
        uploadDate: '2024-01-08',
        verified: true,
      },
    ],
    address: {
      street: '150 Tech Hub',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560037',
      country: 'India',
    },
    notes:
      'Authorized software vendor. Provides excellent technical support and training.',
  },
];

export const mockGuestUsersSummary: UsersSummary = {
  totalUsers: 4,
  activeUsers: 3,
  pendingUsers: 1,
  blockedUsers: 0,
  recentlyAdded: 4,
  statusDistribution: {
    active: 3,
    inactive: 0,
    pending: 1,
    blocked: 0,
  },
};
